module.exports = __webpack_public_path__ + "img/eyes.cc7fe1dd.png";